<button mat-raised-button class="primary-3" (click)="selectDivergent()">div</button>
<button mat-raised-button class="primary-3" (click)="selectSuccess()">suc</button>
<button mat-raised-button class="primary-3" (click)="selectWaiting()">agua</button>
